import { EPlacingLayoutType } from '../../../types';

interface IGetCurrentLayoutParams {
  isPromotionPackageSelected: boolean;
  isAuctionEnabled: boolean;
}

export function getCurrentLayout(params: IGetCurrentLayoutParams): EPlacingLayoutType {
  const { isPromotionPackageSelected, isAuctionEnabled } = params;

  if (isPromotionPackageSelected && !isAuctionEnabled) {
    return EPlacingLayoutType.packagesWithoutBet;
  }

  if (isPromotionPackageSelected) {
    return EPlacingLayoutType.packages;
  }

  return EPlacingLayoutType.services;
}
